import Moment from 'react-moment/dist/index';
import { useContext } from 'react';
import { FullHeadPane } from '../Pane';
import Attachments from '../../Organismns/Attachments';
import ResourceAdapter from '../../Service/ResourceAdapter';
import { ProfileContext } from '../../Service/Context/ProfileContext';
import { HtmlPlaceholderFormatter } from '../../Atoms/Formatter/HtmlPlaceholderFormatter';
import EmailActions from './EmailActions';
import { ChatMessageEventRelation } from './ChatMessageEventRelation';
import { PersonDescriptionAndEmail } from './ChatMessagePersonDescription';
import { ChatMessageEventRole } from './ChatMessageEventRole';

const ChatMessage = ({ id, message, event, customer, changeEmailById, setEmailAction, eventLocation }) => {
  const { profile } = useContext(ProfileContext);

  const styles = {
    head: {
      flex: 1,
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
    firstLine: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    personDescriptionAndEmail: {
      fontSize: 13,
    },
    subject: {
      fontSize: 16,
      color: '#000000',
      margin: 15,
    },
    send: {
      fontSize: 11,
    },
    read: {
      fontSize: 11,
    },
    attachments: {
      marginTop: 10,
    },
  };

  let customerContact = message.sendByUser ? (message.to && message.to.length > 0 ? message.to[0] : {}) : message.from;
  if (!customerContact) customerContact = {};
  const toContactId = message.to ? message.to[0].contactId : null;
  const fromContactId = message.from ? message.from.contactId : null;
  return (
    <div id={id} className="email">
      <div style={styles.subject}>
        <HtmlPlaceholderFormatter
          label
          value={message.subject}
          event={event}
          eventLocation={eventLocation}
          customer={customer}
        />
      </div>
      <FullHeadPane
        head={
          <div style={styles.head}>
            <div style={styles.firstLine}>
              <div>
                <PersonDescriptionAndEmail
                  style={styles.personDescriptionAndEmail}
                  personDescription={customerContact.personDescription}
                  email={customerContact.email}
                />
                <ChatMessageEventRole
                  profileContactId={profile.contactId}
                  emailToId={toContactId}
                  emailFromId={fromContactId}
                />

                <div>
                  {message.localDateTime && (
                    <div style={styles.send}>{renderGermanDateTime(message.localDateTime)}</div>
                  )}
                  {!message.localDateTime && (
                    <div style={styles.read}> Entwurf, {renderGermanDateTime(message.lastModified)}</div>
                  )}
                </div>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <ChatMessageEventRelation
                  profileContactId={profile.contactId}
                  emailToId={toContactId}
                  emailFromId={fromContactId}
                  eventId={message.eventId}
                />
                <EmailActions email={message} changeEmailById={changeEmailById} setEmailAction={setEmailAction} />
              </div>
            </div>

            <ResourceAdapter
              serviceUrl={`${process.env.REACT_APP_FILE_SERVICE_URL}/files/messages/${message.id}`}
              component={({ data }) => {
                data.forEach((file) => {
                  file.entityType = 'messages';
                  file.entityId = message.id;
                });

                return (
                  <div style={styles.attachments}>
                    <Attachments attachments={data} />
                  </div>
                );
              }}
            />
          </div>
        }
        body={
          <HtmlPlaceholderFormatter
            label
            value={message.message}
            event={event}
            eventLocation={eventLocation}
            customer={customer}
          />
        }
      />
    </div>
  );
};

const calendarStrings = {
  lastDay: '[Gestern, ] LT',
  sameDay: '[Heute, ] LT',
  nextDay: '[Morgen, ] LT',
  lastWeek: 'dd[,] LT',
  sameElse: 'L',
};
function renderGermanDateTime(datetime) {
  return (
    <Moment locale="de" calendar={calendarStrings}>
      {datetime}
    </Moment>
  );
}

export default ChatMessage;
